import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.html',
    styleUrls: ['./footer.scss']
})
export class FooterComponent {   
}


// WEBPACK FOOTER //
// ./src/app/components/footer/footer.ts